import type {
  FlipkartAdsEntitySyncResult,
  FlipkartAdsEntitySyncStatus,
  FlipkartAdsReportSyncResult,
} from '@/api/client';

export function formatFlipkartEntitySyncToast(data: FlipkartAdsEntitySyncResult): string {
  return `Synced ${data.campaigns.upserted} campaigns, ${data.ad_groups.upserted} ad groups, ${data.keywords.upserted} keywords, ${data.products.upserted} products`;
}

export function flipkartEntitySyncCooldownFromDetail(
  detail: unknown
): FlipkartAdsEntitySyncStatus | null {
  if (!detail || typeof detail !== 'object') return null;
  const body = detail as { error?: unknown; available_at?: unknown; retry_after_seconds?: unknown };
  if (body.error !== 'flipkart_ads_entity_sync_cooldown') return null;
  if (typeof body.available_at !== 'string') return null;
  const retry = Number(body.retry_after_seconds);
  return {
    available_at: body.available_at,
    retry_after_seconds: Number.isFinite(retry) ? Math.max(0, Math.ceil(retry)) : 0,
  };
}

export function flipkartEntitySyncRetrySeconds(
  availableAt: string | null | undefined,
  nowMs: number
): number {
  if (!availableAt) return 0;
  const end = new Date(availableAt).getTime();
  if (!Number.isFinite(end)) return 0;
  return Math.max(0, Math.ceil((end - nowMs) / 1000));
}

export function formatFlipkartEntitySyncButtonLabel(retryAfterSeconds: number): string {
  if (retryAfterSeconds <= 0) return 'Sync entities';
  const minutes = Math.max(1, Math.ceil(retryAfterSeconds / 60));
  return `Sync entities (${minutes}m)`;
}

export function formatFlipkartReportsSyncToast(data: FlipkartAdsReportSyncResult): string {
  const upserted = Object.values(data.grains).reduce(
    (sum, grain) => sum + (grain?.upserted ?? 0),
    0
  );
  return `Synced ${upserted.toLocaleString()} report rows (${data.window_start} to ${data.window_end})`;
}
